import Vue from 'vue'
import { slugify } from '@/helpers/slugify-helper'

Vue.filter('slugify', (value: string) => {
  return slugify(value)
})
